import { Button } from "primereact/button";
import { FC, useState } from "react";
import { useResponsive } from "../../../../responsive/ResponsiveProvider";
import { AboutSection } from "../../../../models/manageWebSite";
import EditModal from "./EditModal";
interface Section3Props {
  data: AboutSection | null;
  flag: boolean;
  setFlag: (flag: boolean) => void;
  homeId: string | null;
}
const Section3: FC<Section3Props> = ({ data, flag, setFlag, homeId }) => {
  const mobile = useResponsive().isMobile;
  const [openModal, setOpenModal] = useState<boolean>(false);

  return (
    <div
      style={{
        width: "100%",
        padding: mobile ? "2rem 1rem" : "3rem 1.5rem",
        background: "linear-gradient(180deg, #f8fbff 0%, #eef6ff 100%)",
      }}
      className="scroll-slide-section"
    >
      <div
        style={{
          maxWidth: "1180px",
          margin: "0 auto",
          background: "#ffffff",
          border: "1px solid #d9e8f5",
          borderRadius: "32px",
          boxShadow: "0 26px 50px rgba(15,61,99,0.1)",
          padding: mobile ? "1rem" : "1.5rem",
        }}
      >
        <div
          className="grid align-items-center"
          style={{
            display: "grid",
            gridTemplateColumns: mobile ? "1fr" : "minmax(320px, 460px) minmax(0, 1fr)",
            gap: mobile ? "1rem" : "2rem",
          }}
        >
        <div className="flex flex-wrap justify-content-center align-items-center">
          <img
            src={data?.sectionSignedImg}
            style={{
              objectFit: "cover",
              backgroundColor: "transparent",
              height: mobile ? "280px" : "520px",
              width: "100%",
              maxWidth: "460px",
              borderRadius: "26px",
              boxShadow: "0 18px 38px rgba(15,61,99,0.12)",
            }}
          />
        </div>
        <div className="flex flex-wrap justify-content-center align-items-center">
          <div
            className="w-100 h-100 d-flex flex-column gap-2"
            style={{
              overflowY: "auto",
              padding: mobile ? "0.5rem 0.25rem" : "0.5rem 1rem 0.5rem 0.25rem",
            }}
          >
            <div style={{ color: "#9a3412", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", fontSize: "0.8rem" }}>
              About the home
            </div>
            <p
              style={{
                fontSize: mobile ? "1.45rem" : "2.25rem",
                lineHeight: 1.25,
                color: "#0f172a",
                fontWeight: 800,
                margin: "0.9rem 0 0",
              }}
            >
              {data?.title}
            </p>
            <p
              style={{
                fontSize: mobile ? "0.98rem" : "1.08rem",
                lineHeight: 1.9,
                color: "#5f7488",
                margin: "1rem 0 0",
                whiteSpace: "pre-line",
              }}
            >
              {data?.description}
            </p>
            <div className="mt-4">
              <Button label="Edit About Section" severity="warning" onClick={() => setOpenModal(true)} className="website-section-action-button" />
            </div>
          </div>
        </div>
        </div>
      </div>

      <EditModal
        isOpen={openModal}
        toggleModal={setOpenModal}
        flag={flag}
        setFlag={setFlag}
        homeId={homeId}
        data={data}
      />
    </div>
  );
};

export default Section3;
